import { isReactNative, isWeapp, isWeb } from 'yofobasement/utils/runtime';

const currentOS = isReactNative() ? require('react-native').Platform.OS : 'web';

export default {
  OS: currentOS,
  select: ({ web, android, ios } = {}) => {
    if (isReactNative()) {
      return require('react-native').Platform.select({ web, android, ios });
    }
    if (isWeapp() || isWeb()) {
      return web;
    } else {
      return ios;
    }
  }
};



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/Platform.js